var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWrapper',{style:(_vm.backgroundImage)},[_c('NavbarMainMobile'),_c('NavbarMain'),_c('BaseAlertMessage'),_c('HomeWrapper'),_c('Footer',{staticClass:"FooterHome"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }